(function() {
  if (window.__productVariantSectionRenderInit) return;
  window.__productVariantSectionRenderInit = true;

  var mediaDebugEnabled = window.location.search.indexOf('debug_media=1') > -1 || window.localStorage.getItem('debug_media') === '1' || window.__forceMediaDebug === true;
  window.__MEDIA_DEBUG_EVENTS = window.__MEDIA_DEBUG_EVENTS || [];
  function mediaDebugLog(source, payload) {
    if (!mediaDebugEnabled) return;
    try {
      var entry = {
        ts: Date.now(),
        source: '[OVER-250] ' + source,
        payload: payload || {}
      };
      window.__MEDIA_DEBUG_EVENTS.push(entry);
      if (window.__MEDIA_DEBUG_EVENTS.length > 400) {
        window.__MEDIA_DEBUG_EVENTS.shift();
      }
      console.warn('[MEDIA-DEBUG][OVER-250]', source, payload || {});
    } catch (e) {}
  }
  mediaDebugLog('init', { href: window.location.href });

  function updateProductSection(input, targetUrl) {
    var sectionRoot = input.closest('[data-section-type="product"]');
    if (!sectionRoot) {
      window.location.assign(targetUrl);
      return;
    }

    var sectionId = sectionRoot.getAttribute('data-section-id');
    if (!sectionId) {
      window.location.assign(targetUrl);
      return;
    }

    var sectionUrl = targetUrl + (targetUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    var changedOptionName = input.getAttribute('name') || '';
    var changedOptionValue = input.value || '';
    var selectedByName = {};
    var currentCheckedInputs = sectionRoot.querySelectorAll('[data-over-250-option-selector]:checked');
    for (var s = 0; s < currentCheckedInputs.length; s++) {
      var selectedInput = currentCheckedInputs[s];
      selectedByName[selectedInput.getAttribute('name') || ''] = selectedInput.value || '';
    }
    if (changedOptionName) {
      selectedByName[changedOptionName] = changedOptionValue;
    }

    mediaDebugLog('updateProductSection:start', {
      sectionId: sectionId,
      changedOptionName: changedOptionName,
      changedOptionValue: changedOptionValue,
      targetUrl: targetUrl,
      sectionUrl: sectionUrl
    });

    window.fetch(sectionUrl, { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Section request failed');
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshOptionClassMap = {};
        var currentActiveSlide = sectionRoot.querySelector('[data-product-slideshow] .product__media.is-selected');
        var previousMediaId = currentActiveSlide ? currentActiveSlide.getAttribute('data-media-id') : '';

        var freshOptionInputs = doc.querySelectorAll('[data-over-250-option-selector]');
        for (var n = 0; n < freshOptionInputs.length; n++) {
          var freshOptionInput = freshOptionInputs[n];
          var freshKey = (freshOptionInput.getAttribute('name') || '') + '||' + (freshOptionInput.value || '');
          freshOptionClassMap[freshKey] = freshOptionInput.className || '';
        }

        function syncOptionClasses() {
          var currentOptionInputs = sectionRoot.querySelectorAll('[data-over-250-option-selector]');
          for (var p = 0; p < currentOptionInputs.length; p++) {
            var currentOptionInput = currentOptionInputs[p];
            var currentKey = (currentOptionInput.getAttribute('name') || '') + '||' + (currentOptionInput.value || '');
            if (Object.prototype.hasOwnProperty.call(freshOptionClassMap, currentKey)) {
              currentOptionInput.className = freshOptionClassMap[currentKey];
            }
          }
        }

        var freshInfo = doc.querySelector('#product__info');
        var currentInfo = sectionRoot.querySelector('#product__info');
        if (freshInfo && currentInfo) {
          currentInfo.innerHTML = freshInfo.innerHTML;
        }

        var isColorChange = /options\[color\]/i.test(changedOptionName);

        function selectMediaById(mediaId) {
          if (!mediaId) return;
          var slideshow = sectionRoot.querySelector('[data-product-slideshow]');
          var activeMedia = sectionRoot.querySelector('[data-product-slideshow] .product__media.is-selected');
          var activeMediaId = activeMedia ? activeMedia.getAttribute('data-media-id') : '';
          if (String(activeMediaId) === String(mediaId)) return;

          var mediaThumb = sectionRoot.querySelector('[data-slideshow-thumbnail][data-media-select="' + mediaId + '"]');
          if (mediaThumb) {
            mediaThumb.click();
          }

          mediaDebugLog('selectMediaById', {
            mediaId: mediaId,
            activeMediaId: activeMediaId,
            thumbFound: !!mediaThumb
          });

          var imageChangeEvent = new CustomEvent('theme:image:change', {
            bubbles: true,
            detail: { id: mediaId }
          });

          if (slideshow) {
            slideshow.dispatchEvent(imageChangeEvent);
          } else {
            sectionRoot.dispatchEvent(imageChangeEvent);
          }
        }

        if (!isColorChange && previousMediaId) {
          selectMediaById(previousMediaId);
          window.setTimeout(function() {
            selectMediaById(previousMediaId);
          }, 120);
          window.setTimeout(function() {
            selectMediaById(previousMediaId);
          }, 380);
        }

        syncOptionClasses();
        window.setTimeout(syncOptionClasses, 50);

        var refreshedOptionInputs = sectionRoot.querySelectorAll('[data-over-250-option-selector]');
        for (var k = 0; k < refreshedOptionInputs.length; k++) {
          var refreshedInput = refreshedOptionInputs[k];
          var refreshedName = refreshedInput.getAttribute('name') || '';
          if (!refreshedName || !Object.prototype.hasOwnProperty.call(selectedByName, refreshedName)) continue;
          if (refreshedInput.value !== selectedByName[refreshedName]) continue;
          refreshedInput.checked = true;

          var legendWrapper = refreshedInput.closest('.selector-wrapper');
          var legendTarget = legendWrapper ? legendWrapper.querySelector('[data-swapper-target]') : null;
          if (legendTarget) {
            legendTarget.textContent = selectedByName[refreshedName];
          }
        }

        if (!isColorChange) {
          var checkedUnavailable = sectionRoot.querySelectorAll('[data-over-250-option-selector]:checked.unavailable, [data-over-250-option-selector]:checked.sold-out');
          var invalidChecked = null;
          for (var m = 0; m < checkedUnavailable.length; m++) {
            var checkedInput = checkedUnavailable[m];
            if (checkedInput.getAttribute('name') === changedOptionName) continue;
            invalidChecked = checkedInput;
            break;
          }
          if (!invalidChecked && checkedUnavailable.length) {
            invalidChecked = checkedUnavailable[0];
          }

          if (invalidChecked) {
            var groupName = invalidChecked.getAttribute('name');
            var groupInputs = sectionRoot.querySelectorAll('[data-over-250-option-selector]');
            var replacement = null;

            for (var i = 0; i < groupInputs.length; i++) {
              var candidate = groupInputs[i];
              if (candidate.getAttribute('name') !== groupName) continue;
              if (candidate.classList.contains('unavailable') || candidate.classList.contains('sold-out')) continue;
              replacement = candidate;
              break;
            }

            if (replacement && replacement !== invalidChecked) {
              replacement.checked = true;
              replacement.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }
        }

        var freshIdInput = freshInfo ? freshInfo.querySelector('input[name="id"]') : doc.querySelector('input[name="id"]');
        var nextVariantId = freshIdInput ? freshIdInput.value : '';
        if (nextVariantId) {
          var idInputs = sectionRoot.querySelectorAll('input[name="id"]');
          for (var j = 0; j < idInputs.length; j++) {
            idInputs[j].value = nextVariantId;
          }
        }

        var historyUrl = new URL(window.location.href);
        if (nextVariantId) {
          historyUrl.searchParams.set('variant', nextVariantId);
          historyUrl.searchParams.delete('option_values');
        } else {
          historyUrl.search = targetUrl.split('?')[1] || '';
        }
        window.history.replaceState({ path: historyUrl.toString() }, '', historyUrl.toString());

        var mediaId = input.getAttribute('data-variant-media-id');
        if (mediaId && isColorChange) {
          mediaDebugLog('colorChange:mediaSync', {
            mediaId: mediaId
          });
          selectMediaById(mediaId);
          window.setTimeout(function() {
            selectMediaById(mediaId);
          }, 120);
        }

        var checkedUnavailableOption = sectionRoot.querySelector('[data-over-250-option-selector]:checked.unavailable');
        var checkedSoldOutOption = sectionRoot.querySelector('[data-over-250-option-selector]:checked.sold-out');
        var addToCartButtons = sectionRoot.querySelectorAll('[data-add-to-cart]');
        var addToCartTextNodes = sectionRoot.querySelectorAll('[data-add-to-cart-text]');
        var isPurchasable = !checkedUnavailableOption && !checkedSoldOutOption;

        for (var q = 0; q < addToCartButtons.length; q++) {
          addToCartButtons[q].disabled = !isPurchasable;
        }

        for (var r = 0; r < addToCartTextNodes.length; r++) {
          var textNode = addToCartTextNodes[r];
          var defaultText = textNode.getAttribute('data-add-to-cart-text') || textNode.textContent || 'Add to Cart';
          if (isPurchasable) {
            textNode.textContent = defaultText;
          } else if (checkedSoldOutOption) {
            textNode.textContent = 'Sold Out';
          } else {
            textNode.textContent = 'Unavailable';
          }
        }

        if (currentInfo) {
          currentInfo.classList.remove('variant--unavailable', 'variant--soldout');
          if (!nextVariantId || checkedUnavailableOption) {
            currentInfo.classList.add('variant--unavailable');
          } else if (checkedSoldOutOption) {
            currentInfo.classList.add('variant--soldout');
          }
        }

        mediaDebugLog('updateProductSection:complete', {
          nextVariantId: nextVariantId,
          isColorChange: isColorChange,
          checkedUnavailableOption: !!checkedUnavailableOption,
          checkedSoldOutOption: !!checkedSoldOutOption,
          isPurchasable: isPurchasable
        });
      })
      .catch(function() {
        mediaDebugLog('updateProductSection:errorRedirect', {
          targetUrl: targetUrl
        });
        window.location.assign(targetUrl);
      });
  }

  function syncInitialOver250Media(sectionRoot) {
    if (!sectionRoot || !sectionRoot.querySelector('[data-over-250-option-selector]')) return;

    var checkedColorInput = sectionRoot.querySelector('input[data-over-250-option-selector][name="options[Color]"]:checked')
      || sectionRoot.querySelector('input[data-over-250-option-selector][name="options[color]"]:checked')
      || sectionRoot.querySelector('input[data-over-250-option-selector][name*="Color"]:checked')
      || sectionRoot.querySelector('input[data-over-250-option-selector][name*="color"]:checked');

    var mediaId = checkedColorInput ? checkedColorInput.getAttribute('data-variant-media-id') : '';
    var slideshow = sectionRoot.querySelector('[data-product-slideshow]');
    if (!mediaId || !slideshow) return;

    var evt = new CustomEvent('theme:image:change', {
      bubbles: true,
      detail: { id: mediaId }
    });

    slideshow.dispatchEvent(evt);
    window.setTimeout(function() { slideshow.dispatchEvent(evt); }, 120);
    window.setTimeout(function() { slideshow.dispatchEvent(evt); }, 500);

    mediaDebugLog('syncInitialOver250Media', {
      mediaId: mediaId,
      checkedColor: checkedColorInput && checkedColorInput.value
    });
  }

  document.addEventListener('change', function(event) {
    var input = event.target;
    if (!input || !input.matches('[data-over-250-option-selector]')) return;

    var targetUrl = input.getAttribute('data-variant-url');
    if (!targetUrl || targetUrl === window.location.href) return;

    mediaDebugLog('changeEvent', {
      inputName: input.getAttribute('name'),
      inputValue: input.value,
      targetUrl: targetUrl
    });

    updateProductSection(input, targetUrl);
  });

  document.addEventListener('DOMContentLoaded', function() {
    var productSections = document.querySelectorAll('[data-section-type="product"]');
    for (var i = 0; i < productSections.length; i++) {
      syncInitialOver250Media(productSections[i]);
    }
  });

  document.addEventListener('shopify:section:load', function(event) {
    syncInitialOver250Media(event && event.target ? event.target : null);
  });
})();
